const CreditCard = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.95835 3.33594C2.6927 3.33594 1.66669 4.36195 1.66669 5.6276V7.50016H18.3301V8.75016H1.66669V14.3719C1.66669 15.6376 2.6927 16.6636 3.95835 16.6636L16.0384 16.6636C17.3041 16.6636 18.3301 15.6376 18.3301 14.3719L18.3301 7.53843C18.3302 6.8999 18.3302 6.26105 18.3297 5.62227C18.3287 4.35793 17.3028 3.33594 16.04 3.33594H3.95835ZM5.62502 10.4168C5.27984 10.4168 5.00002 10.6967 5.00002 11.0418C5.00002 11.387 5.27984 11.6668 5.62502 11.6668H8.12502C8.4702 11.6668 8.75002 11.387 8.75002 11.0418C8.75002 10.6967 8.4702 10.4168 8.12502 10.4168H5.62502Z"
      fill="currentColor"
    />
  </svg>
)

export default CreditCard
